<template>
  <div class="about">
    <p class="profile">企业简介</p>
    <p class="profileText" v-html="list.company"></p>
    <div class="aboutNumber"></div>
    <p class="profile">我们的愿景</p>
    <p class="profileText textAlign" v-html="list.enterprisevision"></p>
    <p class="profile">我们的使命</p>
    <p class="profileText textAlign" v-html="list.mission"></p>
    <p class="profile">我们的价值观</p>
    <p class="profileText textAlign" v-html="list.value">
      <!-- 客户第一&nbsp;&nbsp;&nbsp;&nbsp;服务至上&nbsp;&nbsp;&nbsp;&nbsp;技术创新&nbsp;&nbsp;&nbsp;&nbsp;拥抱变化<br />
      精工细造&nbsp;&nbsp;&nbsp;&nbsp;爱岗敬业&nbsp;&nbsp;&nbsp;&nbsp;快乐奋斗&nbsp;&nbsp;&nbsp;&nbsp;员工幸福-->
    </p>
    <p class="profile">企业文化</p>
    <ul class="cultureList">
      <li v-for="(item,index) in culture" :key="index">
        <div class="cultureTitle">{{item.title}}</div>
        <div class="culturePic">
          <img :src="item.img" alt="社会责任" class="showPic" />
          <img :src="item.show" alt="社会责任" class="hidePic" />
        </div>
        <div class="cultureDesc">{{item.desc}}</div>
      </li>
    </ul>
    <p class="profile clear">售后服务</p>
    <p class="profileText" v-html="list.content">
      <!-- <ul>
				<li>1.卖方提供免费的设备现场安装、调试、咨询及与设备相关的检修、维护、保养、安全操作常识的培训。（仅包括国内地区)</li>
				<li>提供长久的技术支持和备品备件的及时供应，终身免费维修。</li>
				<li>3.接到客户反馈电话后，12小时给予回复，24小时到达现场，48小时解决问题</li>
				<li>4.建立客户档案，定期做客户回访，协助客户对设备维护保养</li>
      </ul>-->
    </p>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      culture: [
        {
          id: 1,
          title: "社会责任",
          desc: "节能环保、先进高效、创造一个清洁的绿色世界",
          img: require("../../assets/images/about/xin.png"),
          show: require("../../assets/images/about/xinshow.png"),
        },
        {
          id: 2,
          title: "企业形象",
          desc: "诚实待人、诚信感人、诚信送人、诚恳让人",
          img: require("../../assets/images/qywh.png"),
          show: require("../../assets/images/about/jylnshow.png"),
        },
        {
          id: 3,
          title: "经营理念",
          desc: "诚信服务、不断提高技术、精心制造产品、品牌智迎天下",
          img: require("../../assets/images/about/jyln.png"),
          show: require("../../assets/images/about/jllnshow.png"),
        },
        {
          id: 4,
          title: "组织结构",
          desc:
            "现代化企业管理机制体系，严谨有序的组织结构，年轻且专业化的人才组合",
          img: require("../../assets/images/about/zjjg.png"),
          show: require("../../assets/images/about/zjjgshow.png"),
        },
      ],
      list: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      request
        .post(this.settings.apiBaseUrl + "/api/index/about", qs.stringify({}), {
          headers: {},
        })
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.about {
  clear: both;
  width: 100%;
  height: auto;
}

.about .profile {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #191919;
  margin-bottom: 50px;
}

.about .profileText {
  display: block;
  width: 80%;
  margin: 0 auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  /* color: #727272; */
  line-height: 40px;
  margin-bottom: 60px;
}
.profileText ul li {
  text-align: left;
  margin-bottom: 10px;
}
.aboutNumber {
  width: 95%;
  height: 220px;
  margin: 50px auto;
  background-image: url(../../assets/images/about1.png);
  background-size: 100% 100%;
}

.textAlign {
  text-align: center;
  padding-bottom: 40px;
}

.wenhuaPic {
  width: 119px;
  height: 110px;
  margin-right: 90px;
}

.cultureList {
  margin-top: 60px;
}

.cultureList li {
  width: 23%;
  height: 410px;
  float: left;
  margin-right: 20px;
  padding: 40px;
  transition: all 0.5s ease;
  margin-bottom: 50px;
}

.cultureList li:hover {
  background-color: #216bd1;
}

.cultureList li:hover .cultureTitle,
.cultureList li:hover .cultureDesc {
  transition: all 0.5s ease;
  color: #ffffff;
}

.cultureList li:hover .showPic {
  display: none;
}

.cultureList li:hover .hidePic {
  display: block;
  margin: 0 auto;
}

.cultureTitle {
  text-align: center;
  height: 21px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #252525;
  line-height: 29px;
  margin-bottom: 70px;
}

.culturePic {
  width: 100%;
  height: auto;
  text-align: center;
}

.culturePic img {
  width: auto;
  height: auto;
}

.cultureDesc {
  margin-top: 55px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  /* color:#727272; */
  line-height: 24px;
}

.hidePic {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue